/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ellipsis_CharInputs */

const en_ellipsis_char = /** @type {(inputs: Ellipsis_CharInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( … ) Ellipsis`)
};

const fr_ellipsis_char = /** @type {(inputs: Ellipsis_CharInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( … ) Points de suspension`)
};

const de_ellipsis_char = /** @type {(inputs: Ellipsis_CharInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( … ) Auslassungspunkte`)
};

const it_ellipsis_char = /** @type {(inputs: Ellipsis_CharInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( … ) Ellissi`)
};

const ru_ellipsis_char = /** @type {(inputs: Ellipsis_CharInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( … ) Многоточие`)
};

const es_ellipsis_char = /** @type {(inputs: Ellipsis_CharInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( … ) Elipsis`)
};

const zh_cn2_ellipsis_char = /** @type {(inputs: Ellipsis_CharInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`（…）省略号`)
};

const ja_ellipsis_char = /** @type {(inputs: Ellipsis_CharInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`（…）省略記号`)
};

const hi_ellipsis_char = /** @type {(inputs: Ellipsis_CharInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( … ) दीर्घवृत्त`)
};

const pt_pt2_ellipsis_char = /** @type {(inputs: Ellipsis_CharInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(...) Elipse`)
};

/**
* | output |
* | --- |
* | "( … ) Ellipsis" |
*
* @param {Ellipsis_CharInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ellipsis_char = /** @type {((inputs?: Ellipsis_CharInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ellipsis_CharInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ellipsis_char(inputs)
	if (locale === "de") return de_ellipsis_char(inputs)
	if (locale === "it") return it_ellipsis_char(inputs)
	if (locale === "ru") return ru_ellipsis_char(inputs)
	if (locale === "es") return es_ellipsis_char(inputs)
	if (locale === "zh-CN") return zh_cn2_ellipsis_char(inputs)
	if (locale === "ja") return ja_ellipsis_char(inputs)
	if (locale === "hi") return hi_ellipsis_char(inputs)
	if (locale === "pt-PT") return pt_pt2_ellipsis_char(inputs)
	return en_ellipsis_char(inputs)
});